import type { ActionHandlers, ActionMap, Message, SpanContext } from "@/types/dispatch.types.tsx";

export const NoSpan: SpanContext = {
  traceId: "",
  spanId: "",
  parentId: null,
  dispatch: () => "",
  span: (_name, work) => work(NoSpan),
};

export function reduce<S, A extends ActionMap>(
  handlers: ActionHandlers<A, S>,
  state: S,
  message: Message<A>,
  span: SpanContext<A> = NoSpan,
): S {
  const handler = handlers[message.type as keyof A];
  if (typeof handler !== "function") {
    throw new TypeError(`no handler for action "${String(message.type)}"`);
  }

  const payload = ("payload" in message ? message.payload : undefined) as A[keyof A];
  return handler({ state, action: message.type as keyof A, payload, span });
}

export function makeReducer<S, A extends ActionMap>(handlers: ActionHandlers<A, S>) {
  return (state: S, message: Message<A>): S => reduce(handlers, state, message);
}
